import { render, staticRenderFns } from "./AddressTransactionCard.vue?vue&type=template&id=5c608893&scoped=true&"
import script from "./AddressTransactionCard.vue?vue&type=script&lang=js&"
export * from "./AddressTransactionCard.vue?vue&type=script&lang=js&"
import style0 from "./AddressTransactionCard.vue?vue&type=style&index=0&id=5c608893&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c608893",
  null
  
)

export default component.exports